module.exports = __webpack_public_path__ + "img/card_title_middle.a1c53bce.png";